export function getUser() {
  try {
    const raw = localStorage.getItem('ac_user')
    return raw ? JSON.parse(raw) : null
  } catch { return null }
}